import React, { useState, useEffect, useRef } from "react";
import { Menu, Dropdown, Modal, Popover, Row, Col, Badge } from "antd";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { useAuthContext } from "../../common/providers/AuthProvider";
import { useSytContext } from "../../common/providers/SytProvider";
import APIClient from "../../helpers/ApiClient";
import FlagsList from "./FlagsList";
import Login from "../../components/Login/Login";
import dayjs from "dayjs";
import { formatDate, DISPLAY_FORMAT } from "../../helpers/dateHelper";
import "../navbar/Navbar.scss";
import ContactUsModal from "./ContactUsModal";
import { useActivitiesContext } from "../providers/Activities/ActivitiesProvider";
import NewBlinkImage from '../../assets/images/logos/New_Blink.gif';
import HurryBlinkImage from '../../assets/images/logos/Hurry_Blink.gif';
import {
  CaretDownOutlined,
  UserOutlined,
  ShoppingCartOutlined,
  SyncOutlined,
  CustomerServiceOutlined,
  // UserSwitchOutlined,
} from "@ant-design/icons";

/** Set true to show the HURRY blink badge on the Road Show nav tab. */
const SHOW_ROAD_SHOW_HURRY_BADGE = false;

/** Agent header: show agency name; fallback to first name if missing. */
const getAgentWelcomeLabel = (user) => {
  const agency = String(user?.AgencyName ?? "").trim();
  if (agency) {
    return agency;
  }
  return String(user?.FirstName ?? "").trim() || "Agent";
};

const Nav = ({ location }) => {
  const { logo, roadShowNavVisible, refreshRoadShowNavSetting } = useSytContext();
  const BASE = process.env.REACT_APP_BASE_URL;
  const {
    isLogin: { flag, agent },
    user,
    setUser,
    resetIsLogin,
    accessToken,
    isLoading,
  } = useAuthContext();
  const {
    state: { activitiesLocalCart, activitiesCart, isCartUpdating },
    setSelectedBuildActivities,
  } = useActivitiesContext();
  let users=[];
  let navigate = useNavigate();
  const [fetchingWallet, setFetchingWallet] = useState(false);
  const [navToggle, setNavToggle] = useState(false);
  const [contactUsOpen, setContactUsOpen] = useState(false);
  // const [userNav, setuserNav] = useState({Services:["1","2","4","5"]});
  const [userNav, setuserNav] = useState({Services:["1","2","4","5","6"]});


  const hasActiveSession =
    Boolean(user) || (Boolean(accessToken) && isLoading);
  const sessionPending = Boolean(accessToken) && !user && isLoading;
  const isAgentSession =
    agent ||
    Number(user?.Role?.RoleId) === 5 ||
    Number(user?.Role?.RoleLevel) === 3;

  useEffect(() => {
    refreshRoadShowNavSetting?.();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const logout = () => {
    resetIsLogin();
    setSelectedBuildActivities([]);
    navigate("/");
  };

  const logoutTimerRef = useRef(null);

  const resetTimer = () => {
    if (logoutTimerRef.current) clearTimeout(logoutTimerRef.current);
    // 2 hours = 7200000 ms
    logoutTimerRef.current = setTimeout(() => {
      logout();
    }, 7200000);
  };

  useEffect(() => {
    const events = ["mousemove", "keydown", "click", "scroll"];
    events.forEach((event) => window.addEventListener(event, resetTimer));

    // Start timer
    resetTimer();

    return () => {
      if (logoutTimerRef.current) clearTimeout(logoutTimerRef.current);
      events.forEach((event) =>
        window.removeEventListener(event, resetTimer)
      );
    };
  }, []);

  const toggleCount = () => {
    setNavToggle((prev) => !prev);
  };

  const cartCount =
    (activitiesLocalCart?.TourDetails?.length || 0) ||
    (activitiesCart?.TourDetails?.length || 0);

  const getwalletBalance = () => {
    if (user && (agent || flag)) {
      setFetchingWallet(true);
      APIClient.get(`admin/GetAgentWalletDetails/${user?.UserID}`)
        .then((resp) => {
          if (resp.status == 200) {
            setUser((prev) => ({ ...prev, Walletdetails: resp.data }));
          }
          setFetchingWallet(false);
        })
        .catch((error) => {
          setFetchingWallet(false);
        });
    }
  };
  /*============= check user logged or not =========== */
  const [modalVisible, setModalVisible] = useState({
    visible: false,
    type: "USER",
  });

  const showModal1 = (type) => {
    /*============= check user logged or not =========== */
    setModalVisible({ visible: true, type: type });
  };
  useEffect(() => {
    // Do not reopen login after a successful Partner OTP (cleared via navigate state:null).
    if (location?.state?.login === true && !hasActiveSession) {
      showModal1(location?.state?.loginType || "USER");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location?.state?.login, hasActiveSession]);

  useEffect(() => {
    const onWalletRefresh = () => {
      if (user && (agent || flag)) {
        getwalletBalance();
      }
    };
    window.addEventListener("syt:refresh-agent-wallet", onWalletRefresh);
    return () => {
      window.removeEventListener("syt:refresh-agent-wallet", onWalletRefresh);
    };
  }, [user, agent, flag]);

  const Balance = (
    <Menu>
      <div className="nav-wallet-wrapper">
        {agent ? (
          <span className="d-flex align-items-center justify-content-between">
            <b>Cash : INR{" "}</b>&nbsp;
            {user
              ? user?.Walletdetails
                ? user?.Walletdetails.Amount
                : "0"
              : ""}
            {"  "}
            <SyncOutlined
              spin={fetchingWallet}
              style={{ marginLeft: "10px" }}
              onClick={() => {
                if (!fetchingWallet) getwalletBalance();
              }}
            />
          </span>
        ) : (
          <span className="d-flex align-items-center justify-content-between">
            <b>Balance : INR</b>{" "}&nbsp;
            {user
              ? user?.Walletdetails
                ? user?.Walletdetails.Amount
                : "0"
              : ""}
            {"  "}
            <SyncOutlined
              spin={fetchingWallet}
              style={{ marginLeft: "10px" }}
              onClick={() => {
                if (!fetchingWallet) getwalletBalance();
              }}
            />
          </span>
        )}
      </div>

      {user && user?.Role?.RoleLevel == 3 ? (
        <>
          {user?.Walletdetails?.CreditAmount >= 0 ? (
            <div className="nav-wallet-wrapper">
              <b>Credit Amount : {user?.Walletdetails?.CreditAmount}</b>
            </div>
          ) : null}
          {user ? (
            user?.Walletdetails?.ExpiryDate ? (
              <div className="nav-wallet-wrapper">
                <p className="mb-0">
                  Credit Expires :{" "}
                  {user?.Walletdetails?.ExpiryDate
                    ? formatDate(user?.Walletdetails?.ExpiryDate,
                        "DD-MM-YYYY"
                      )
                    : ""}
                </p>
              </div>
            ) : null
          ) : null}

          <Menu.Item key="15">
            <NavLink
              exact
              activeClassName="selectedNav"
              className="cre-amount-14"
              to="/deposits"
            >
              TOPUP
            </NavLink>
          </Menu.Item>
        </>
      ) : null}
    </Menu>
  );
  const loginMenu = (
    <Menu className="menu-bdr-nav">
      <Menu.Item key="1">
        <NavLink exact activeClassName="selectedNav" to="/profile">
          My Profile
        </NavLink>
      </Menu.Item>

      <Menu.Item key="2">
        <NavLink exact activeClassName="selectedNav" to="/booking-reports">
          My Bookings
        </NavLink>
      </Menu.Item>
      <Menu.Item key="3">
        <NavLink exact activeClassName="selectedNav" to="/mypackage">
          My Package
        </NavLink>
      </Menu.Item>
      <Menu.Item key="4">
        <NavLink exact activeClassName="selectedNav" to="/wallet">
          Wallet
        </NavLink>
      </Menu.Item>
      <Menu.Item key="5">
        <NavLink exact activeClassName="selectedNav" to="/coupon-wallet">
          Coupon Wallet
        </NavLink>
      </Menu.Item>
      <Menu.Item key="6">
        <NavLink exact activeClassName="selectedNav" to="/traveller-details">
          Add Passenger Details
        </NavLink>
      </Menu.Item>
      <Menu.Item key="7">
        <NavLink exact activeClassName="selectedNav" to="/transaction-reports">
          Transaction Reports
        </NavLink>
      </Menu.Item>
      <Menu.Item key="8">
        <NavLink exact activeClassName="selectedNav" to="/change-password">
          Change Password
        </NavLink>
      </Menu.Item>
      {/* Add Logout Features On Mobile View --27/May/2023 TaskId-1003 */}
      <Menu.Item key="11" className="border-bottom-0">
        <span role="button" tabIndex={0} onClick={logout}>
          Logout
        </span>
      </Menu.Item>
      {/* Add Logout Features On Mobile View --27/May/2023 TaskId-1003 */}
    </Menu>
  );

  const AgentMenu = (
    <Menu className="menu-bdr-nav">
      {/* Show who is logged in (mobile + desktop dropdown) */}
      <Menu.Item key="0" disabled className="agent-welcome-item nav-dropdown-mobile-only">
        <span className="text-muted small">
          Welcome {getAgentWelcomeLabel(user)}{" "}
          {agent ? `(${user?.AgentID})` : ""}
        </span>
      </Menu.Item>
      {/* Balance on mobile – same as desktop top bar */}
      {agent && (
        <Menu.Item key="balance" disabled className="agent-balance-item nav-dropdown-mobile-only">
          <div className="nav-wallet-wrapper" style={{ padding: "4px 0" }}>
            <span className="d-flex align-items-center justify-content-between">
              <b>Cash : INR </b>
              {user?.Walletdetails?.Amount ?? "0"}
              <SyncOutlined
                spin={fetchingWallet}
                style={{ marginLeft: "8px" }}
                onClick={(e) => {
                  e.stopPropagation();
                  if (!fetchingWallet) getwalletBalance();
                }}
              />
            </span>
          </div>
        </Menu.Item>
      )}
      <Menu.Item key="1">
        <NavLink exact activeClassName="selectedNav" to="/myprofile">
          My Profile
        </NavLink>
      </Menu.Item>
      {/* <Menu.Item key="2">
        <NavLink exact activeClassName="selectedNav" to="/commission-details">
          My Commissions
        </NavLink>
      </Menu.Item> */}
      <Menu.Item key="3">
        <NavLink exact activeClassName="selectedNav" to="/bank-details">
          Bank Details
        </NavLink>
      </Menu.Item>
      {/* <Menu.Item key="4">
        <NavLink exact activeClassName="selectedNav" to="/agent-markup">
          Markups
        </NavLink>
      </Menu.Item> */}
      <Menu.Item key="5">
        <NavLink exact activeClassName="selectedNav" to="/deposits">
          Deposits
        </NavLink>
      </Menu.Item>
      <Menu.Item key="11">
        <NavLink exact activeClassName="selectedNav" to="/agent-logo">
          Logo
        </NavLink>
      </Menu.Item>
      {/* <Menu.Item key="6">
        <NavLink exact activeClassName="selectedNav" to="/store-vistors">
          Store Visitors
        </NavLink>
      </Menu.Item> */}
      <Menu.Item key="7">
        <NavLink exact activeClassName="selectedNav" to="/booking-reports">
          My Bookings
        </NavLink>
      </Menu.Item>
      <Menu.Item key="8">
        <NavLink exact activeClassName="selectedNav" to="/mypackage">
          My Package
        </NavLink>
      </Menu.Item>
      <Menu.Item key="9">
        <NavLink exact activeClassName="selectedNav" to="/coupon-wallet">
          Coupon Wallet
        </NavLink>
      </Menu.Item>
      {/* <Menu.Item key="13">
        <NavLink exact activeClassName="selectedNav" to="/discounts">
          Discounts
        </NavLink>
      </Menu.Item> */}
      <Menu.Item key="12">
        <NavLink exact activeClassName="selectedNav" to="/statements">
          Statements
        </NavLink>
      </Menu.Item>
      <Menu.Item key="10">
        <NavLink exact activeClassName="selectedNav" to="/change-password">
          Change Password
        </NavLink>
      </Menu.Item>
      <Menu.Item key="logout" className="border-bottom-0 nav-dropdown-mobile-only">
        <span role="button" tabIndex={0} onClick={logout}>
          Logout
        </span>
      </Menu.Item>
    </Menu>
  );
  const LoginMenu = (
    <Menu className="menu-bdr-nav">
      <Menu.Item key="22" >
        <div onClick={() => showModal1("AGENT")}>Partner Login</div>
      </Menu.Item>
      <Menu.Item key="21" className="border-bottom-0">
        <div onClick={() => showModal1("USER")}>User Login</div>
      </Menu.Item>
    </Menu>
  );
  const RegisterMenu = (
    <Menu className="menu-bdr-nav">
      <Menu.Item key="25">
        <NavLink exact activeClassName="selectedNav" to="/agent-registration">
          Partner Registration
        </NavLink>
      </Menu.Item>
      <Menu.Item key="24" className="border-bottom-0">
        <NavLink exact activeClassName="selectedNav" to="/user-registration">
          User Registration
        </NavLink>
      </Menu.Item>
    </Menu>
  );

  const UserDetailsContent = (
    <div>
      <ul className="userPopOver text-capitalize">
        <li><small>name : <strong>{user ? user.FirstName + " " + user.LastName : "Guest"}</strong></small></li>
        <li><small>email : <strong>{user ? user.Email: null}</strong></small></li>
        <li><small>phone no. : <strong>{user ? user.Mobile : null}</strong></small></li>
      </ul>
    </div>
  )

  const shouldShowRepresentativeDetails =
    user?.reprentive &&
    typeof user.reprentive === "object" &&
    (String(user.reprentive.name ?? "").trim() ||
      String(user.reprentive.email ?? "").trim());

  const RepresentativeDetails = (
    <div className="representative-details">
      <div className="title">
        <p>
          Name :{" "}
          <span>
            <b>{user?.reprentive?.name}</b>
          </span>
        </p>
        <p>
          Email :{" "}
          <span>
            <b>{user?.reprentive?.email}</b>
          </span>
        </p>
        <p>
          Designation :{" "}
          <span>
            <b>{user?.reprentive?.department}</b>
          </span>
        </p>
      </div>
    </div>
  );

  const NavbarLinks = ({ user, isGuest, isAgentNav, showRoadShowNav }) => {
    let services = user?.Services ? user?.Services : [];
    const hideTrailingDividerOnSastaEurope =
      !isAgentNav && !showRoadShowNav;
    const location = useLocation();
    const path = location.pathname || "";
    const isSastaEuropeFlow =
      path.startsWith("/sastaeurope") ||
      (path.startsWith("/activities") &&
        new URLSearchParams(location.search).get("source") === "sastaeurope");

    const pathMatch = (prefix) =>
      path === prefix || path.startsWith(`${prefix}/`);

    const navClass = (active) =>
      active ? "selectedNav service-nav-link--active" : "service-nav-link";

    const isFlightsActive =
      path === "/" ||
      pathMatch("/flight") ||
      path === "/flights" ||
      path === "/bookflights" ||
      path === "/agenthomepage";

    const isHotelsActive =
      pathMatch("/hotels") ||
      path.startsWith("/hotel/") ||
      path === "/hotel-location" ||
      path === "/hotel-invoice";

    const isActivitiesActive =
      pathMatch("/activities") && !isSastaEuropeFlow;

    const isBuildPackageActive =
      pathMatch("/buildyourpackage") ||
      pathMatch("/combinedbuildpkg") ||
      pathMatch("/buildquotationtotal") ||
      pathMatch("/Quotationcheckout") ||
      pathMatch("/buildpackage");

    return (
      <>
        {(isGuest || services.includes("1")) && (
          <li onClick={toggleCount}>
            <NavLink to="/" end className={() => navClass(isFlightsActive)}>
              Flights
            </NavLink>
          </li>
        )}
        {(isGuest || services.includes("2")) && (
          <li onClick={toggleCount}>
            <NavLink to="/hotels" className={() => navClass(isHotelsActive)}>
              Hotels{" "}
            </NavLink>
          </li>
        )}
        {(isGuest || services.includes("3")) && (
          <li onClick={toggleCount}>
            <NavLink to="/bus" className={() => navClass(pathMatch("/bus"))}>
              Bus{" "}
            </NavLink>
          </li>
        )}
        {(isGuest || services.includes("4")) && (
          <li onClick={toggleCount}>
            <NavLink
              to="/activities"
              className={() => navClass(isActivitiesActive)}
            >
              Tours & Transfers{" "}
            </NavLink>
          </li>
        )}
        {(isGuest || services.includes("5")) && (
          <li onClick={toggleCount}>
            <NavLink
              to="/buildyourpackage"
              className={() => navClass(isBuildPackageActive)}
            >
              Build Package{" "}
            </NavLink>
          </li>
        )}

        <li style={{ borderRight: "none" }} onClick={toggleCount} className="japan-tour-nav">
          <NavLink
            to="/exclusive-japan-tour-packages"
            title="Exclusive Japan Tour Packages"
            className={() =>
              navClass(
                pathMatch("/exclusive-japan-tour-packages") ||
                  pathMatch("/japan-tour-packages") ||
                  pathMatch("/JapanTour-Package")
              )
            }
          >
            <span className="japan-tour-text">Sasta Japan{" "}</span>
          </NavLink>
        </li>

        {(isGuest || services.includes("7")) && (
          <li onClick={toggleCount}>
            <NavLink
              to="/visa"
              end
              className={({ isActive }) => navClass(isActive)}
            >
              Visa
            </NavLink>
          </li>
        )}

        {(isGuest || services.includes("7")) && (
          <li onClick={toggleCount}>
            <NavLink
              to="/visa-enquiry"
              className={({ isActive }) => navClass(isActive)}
            >
              Visa Enquiry
            </NavLink>
          </li>
        )}

        {(isGuest || services.includes("8")) && (
          <li onClick={toggleCount}>
            <NavLink
              to="/secureyourtrip"
              className={({ isActive }) => navClass(isActive)}
            >
              Secure Your Trip
            </NavLink>
          </li>
        )}
        {(isGuest || services.includes("9")) && (
          <li onClick={toggleCount}>
            <NavLink
              to="/forex"
              className={({ isActive }) => navClass(isActive)}
            >
              Forex
            </NavLink>
          </li>
        )}

          {(isGuest || services.includes("6")) && (
          <li
            style={{
              borderLeft: "1px solid #c7c7c7",
              ...(hideTrailingDividerOnSastaEurope
                ? { borderRight: "none" }
                : {}),
            }}
            onClick={toggleCount}
          >
            <NavLink
              to="/sastaeurope"
              className={() => navClass(isSastaEuropeFlow)}
            >
              Sasta Europe{" "}
             <sup><img src={NewBlinkImage} alt="Sasta Europe" className="imageBelowText" /></sup>
            </NavLink>
          </li>
        )}

        {showRoadShowNav && (
        <li
          onClick={toggleCount}
          style={{ borderRight: "none" }}
          className="border-right-0"
        >
          <NavLink
            to="/road-show"
            className={({ isActive }) => navClass(isActive)}
          >
            Road Show{" "}
            {SHOW_ROAD_SHOW_HURRY_BADGE ? (
              <sup><img src={HurryBlinkImage} alt="Hurry" className="imageBelowText" /></sup>
            ) : null}
          </NavLink>
        </li>
        )}
      </>
    );
  };

  return (
    <div className="header-bg">
      <div className="header-container">
        <div className="wrapper">
          <div className="top-nav-sec">
            <ul className="all-top-menu">
              <li className="mob-none cart-nav-top">
                {user &&
                Object.keys(user).length > 0 &&
                (flag === true ||
                  agent === true ||
                  Number(user?.Role?.RoleId) === 5 ||
                  Number(user?.Role?.RoleLevel) === 3) ? (
                  <React.Fragment>
                    Welcome{" "}
                    {agent || Number(user?.Role?.RoleId) === 5
                      ? getAgentWelcomeLabel(user)
                      : user?.FirstName}{" "}
                    {(agent || Number(user?.Role?.RoleId) === 5) &&
                    user?.AgentID
                      ? `(${user?.AgentID})`
                      : null}
                  </React.Fragment>
                ) : sessionPending ? (
                  <React.Fragment>Welcome…</React.Fragment>
                ) : null}
              </li>
              {shouldShowRepresentativeDetails ? (
                <li className="mob-none cart-nav-top">
                  <Popover content={RepresentativeDetails} title="Agency Representative">
                    Agency Representative
                  </Popover>
                </li>
              ) : null}
              <li className="mob-none cart-nav-top contact-us-top-link">
                <button
                  type="button"
                  className="contact-us-link"
                  onClick={() => setContactUsOpen(true)}
                >
                  <CustomerServiceOutlined className="contact-us-link__icon" />
                  Contact Us
                </button>
              </li>
              {agent !== true ? (
                <li className="mob-none cart-nav-top" onClick={toggleCount}>
                  <NavLink exact to="/mytrips">
                    <span className="user-btn-wrapper">Manage Trips</span>
                  </NavLink>
                </li>
              ) : null}

              <li className="mob-none cart-nav-top" onClick={toggleCount}>
                <NavLink exact to="/activities/cart">
                  <span className="user-btn-wrapper">
                    <Badge
                      count={cartCount}
                      overflowCount={99}
                      size="small"
                      dot={!!isCartUpdating && cartCount === 0}
                      offset={[6, -2]}
                    >
                      <ShoppingCartOutlined />
                    </Badge>
                    Cart
                  </span>
                </NavLink>
              </li>

              <li className="currency-text last-mob-bdr mob-none">
                <FlagsList />
              </li>
              {agent == true ? (
                <li className="mob-none cart-nav-top">
                  <Dropdown overlay={Balance} trigger={["click"]}>
                    <span className="user-btn-wrapper">
                      Balance <CaretDownOutlined className="mr-0" />
                    </span>
                  </Dropdown>
                </li>
              ) : null}

              {user && !agent ? (
                <li className="mob-none cart-nav-top">
                  <Dropdown overlay={Balance} trigger={["click"]}>
                    <span className="user-btn-wrapper">
                      Wallet <CaretDownOutlined className="mr-0" />
                    </span>
                  </Dropdown>
                </li>
              ) : null}
              {flag === true || agent === true ? (
                <li className="mob-none cart-nav-top">
                  <span
                    className="user-btn-wrapper"
                    role="button"
                    tabIndex={0}
                    onClick={logout}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") logout();
                    }}
                  >
                    Logout
                  </span>
                </li>
              ) : null}
            </ul>
          </div>

          <header className="header">
            <div className="app-logo">
              <div className="company-logo" onClick={toggleCount}>
                <NavLink exact activeClassName="selectedNav" to="/">
                  {/* {agent === true ? (
                    agentLogo ? (
                      <img src={BASE + agentLogo.substring(1)} alt="SYT_Logo" />
                    ) : (
                      <img
                        src={
                          require("../../assets/images/logos/trip-logo.png")
                            .default
                        }
                        alt="shopyourtrip"
                      />
                    )
                  )} */}

                  {logo ? (
                    <img src={BASE + logo.substring(1)} alt="SYT_Logo" />
                  ) : (
                    <img
                      src={
                        require("../../assets/images/logos/trip-logo.png")
                          
                      }
                      alt="shopyourtrip"
                    />
                  )}
                </NavLink>
              </div>
              <div className="user-icon">
                <button
                  type="button"
                  className="contact-us-link contact-us-link--mobile d-block d-md-none"
                  onClick={() => setContactUsOpen(true)}
                  aria-label="Contact Us"
                >
                  <CustomerServiceOutlined className="contact-us-link__icon" />
                  Contact Us
                </button>
                <input className="menu-btn" type="checkbox" id="menu-btn" />
                <span className="d-block d-md-none mobile-user">
                  <div className="mobile-user-icon">
                    {flag === true ? (
                      <Dropdown overlay={loginMenu} trigger={["click"]} overlayClassName="nav-account-dropdown">
                        <span className="user-btn-wrapper">
                          <UserOutlined />
                        </span>
                      </Dropdown>
                    ) : agent === true ? (
                      <Dropdown overlay={AgentMenu} trigger={["click"]} overlayClassName="nav-account-dropdown">
                        <span className="user-btn-wrapper">
                          <UserOutlined />
                        </span>
                      </Dropdown>
                    ) : (
                      <span className="user-btn-wrapper" onClick={showModal1}>
                        <UserOutlined />
                      </span>
                    )}
                  </div>
                </span>
                <label className="menu-icon" onClick={toggleCount}>
                  <span className="navicon"></span>
                  <span className="menu-text d-block d-md-none">Menu</span>
                </label>
              </div>
            </div>
            <div className="app-links">
              <ul
                className="menu"
                style={{ maxHeight: navToggle ? "610px" : "0px" }}
              >
                {agent ? (
                  <NavbarLinks user={user} isGuest={false} isAgentNav showRoadShowNav={roadShowNavVisible} />
                ) : (
                  <NavbarLinks user={userNav} isGuest={false} isAgentNav={false} showRoadShowNav={roadShowNavVisible} />//Temporary hide navigation links for users  user?.Services
                )}

                {/* {user?.Role?.RoleId == 5 || user?.Role?.RoleId == 2 ? (
                  <li style={{ borderLeft: "1px solid #c7c7c7" }} onClick={toggleCount}>
                  <NavLink exact activeClassName="selectedNav" to="/coupon-wallet">
                    Redeem Coupon
                  </NavLink>
                </li>
                ) : null} */}

                {/*<li onClick={toggleCount} className={`${agent ? null : "border-right-0"}`}>
                                    <NavLink exact activeClassName="selectedNav" to="/offers"> Offers </NavLink>
                </li> */}
                {/* Temporarily hidden during Road Show event — re-enable after event ends
                {agent && (
                  <li onClick={toggleCount} className="border-right-0">
                    <NavLink
                      exact
                      activeClassName="selectedNav"
                      to="/statements"
                    >
                      Ledger Statements
                    </NavLink>
                  </li>
                )}
                */}

                {/* Mobile-only: Logout when User or Partner is logged in */}
                {(flag || agent) && user && (
                  <li
                    onClick={() => { toggleCount(); logout(); }}
                    className="border-right-0"
                    id="only-mob-user"
                  >
                    <span className="user-btn-wrapper" style={{ cursor: "pointer" }}>
                      Logout
                    </span>
                  </li>
                )}
                {/* Mobile-only quick logins (when not logged in) */}
                {!hasActiveSession && (
                  <>
                    <li
                      onClick={() => showModal1("USER")}
                      className="border-right-0"
                      id="only-mob-user"
                    >
                      <NavLink exact activeClassName="selectedNav" to="">
                        User Login
                      </NavLink>
                    </li>
                    <li
                      onClick={() => showModal1("AGENT")}
                      className="border-right-0"
                      id="only-mob-user"
                    >
                      <NavLink exact activeClassName="selectedNav" to="">
                        Partner Login
                      </NavLink>
                    </li>
                  </>
                )}
                {/* Add User And Partner Registration On Mobile View --27/May/2023 TaskId-1003 */}
                <li onClick={toggleCount} id="only-mob-user">
                  <NavLink
                    exact
                    activeClassName="selectedNav"
                    to="/user-registration"
                  >
                    User Registration
                  </NavLink>
                </li>
                <li onClick={toggleCount} id="only-mob-user">
                  <NavLink
                    exact
                    activeClassName="selectedNav"
                    to="/agent-registration"
                  >
                    Partner Registration
                  </NavLink>
                </li>
                {/* Add User And Partner Registration On Mobile View --27/May/2023  TaskId-1003 */}

                <ul className="d-block d-md-none responive-more">
                  <li className="currency-text currency-panel-text">
                    <FlagsList />
                  </li>
                </ul>
              </ul>
              {hasActiveSession ? (
                <ul className="menu">
                  <li className="border-right-0 mob-none">
                    {flag ? (
                      <Dropdown overlay={loginMenu} trigger={["click"]} overlayClassName="nav-account-dropdown">
                        <span className="user-btn-wrapper">
                          <UserOutlined /> My Account{" "}
                          <CaretDownOutlined className="mr-0" />
                        </span>
                      </Dropdown>
                    ) : isAgentSession || sessionPending ? (
                      <Dropdown overlay={AgentMenu} trigger={["click"]} overlayClassName="nav-account-dropdown">
                        <span className="user-btn-wrapper">
                          <UserOutlined /> My Account
                          <CaretDownOutlined className="mr-0" />
                        </span>
                      </Dropdown>
                    ) : null}
                  </li>
                </ul>
              ) : (
                <ul className="menu">
                  <li className="border-right-0 mob-none">
                    <Dropdown overlay={LoginMenu} trigger={["click"]}>
                      <span className="user-btn-wrapper">
                        Login
                        <CaretDownOutlined className="mr-0" />
                      </span>
                    </Dropdown>
                  </li>
                  <li className="border-right-0 mob-none">
                    <Dropdown overlay={RegisterMenu} trigger={["click"]}>
                      <span className="user-btn-wrapper">
                        Register
                        <CaretDownOutlined className="mr-0" />
                      </span>
                    </Dropdown>
                  </li>
                </ul>
                // <span
                //   className="user-btn-wrapper login-register-mob"
                //   onClick={showModal1}
                // >
                //   <UserOutlined /> Login | Register
                // </span>
              )}
            </div>
          </header>
        </div>
      </div>

      <Modal
        centered
        open={Boolean(modalVisible?.visible)}
        destroyOnHidden
        onOk={() =>
          setModalVisible((prev) => ({
            ...(typeof prev === "object" && prev ? prev : { type: "USER" }),
            visible: false,
          }))
        }
        onCancel={() =>
          setModalVisible((prev) => ({
            ...(typeof prev === "object" && prev ? prev : { type: "USER" }),
            visible: false,
          }))
        }
        className="login-modal"
        footer={false}
      >
        <Login
          location={location}
          setModalVisible={(value) => {
            if (value === false || value === true) {
              setModalVisible((prev) => ({
                ...(typeof prev === "object" && prev
                  ? prev
                  : { type: "USER" }),
                visible: Boolean(value),
              }));
            } else if (value && typeof value === "object") {
              setModalVisible({
                visible: Boolean(value.visible),
                type: value.type || "USER",
              });
            } else {
              setModalVisible({ visible: false, type: "USER" });
            }
          }}
          type={modalVisible?.type || "USER"}
        />
      </Modal>

      <ContactUsModal open={contactUsOpen} onClose={() => setContactUsOpen(false)} />
    </div>
  );
};

export default Nav;
